export const version = '2.10.4: January 13, 2023: Iconography v2';

/**
 * PSEUDO DO NOT CHANGE THIS LINE
 * PSEUDO DO NOT CHANGE THIS LINE
 * PSEUDO DO NOT CHANGE THIS LINE
 * PSEUDO DO NOT CHANGE THIS LINE
 * PSEUDO DO NOT CHANGE THIS LINE
 * PSEUDO DO NOT CHANGE THIS LINE
 */
// eslint-disable-next-line
export const testing: boolean = false;
export const lastUpdated = new Date(Date.UTC(2023, 0, 27, 20, 25, 51));
/**
 * CHANGE THIS ONE INSTEAD
 */
// eslint-disable-next-line
export const prod: boolean = true
